/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { MutationUpsertReserveArgs } from '../gql/graphql';
import { GET_RESERVES } from './reserves.query';
import { GET_CLAIM } from './claim.query';

export function useUpsertReserveMutation(
  options: MutationHookOptions<any, MutationUpsertReserveArgs> = {}
) {
  const [upsertReserve, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation upsertReserve($reserveInput: ReserveInput!) {
        upsertReserve(details: $reserveInput) {
          uuid
          tenant
          totalIncurred
          paymentTotal
          remainingReserve
        }
      }
    `),
    {
      refetchQueries: [GET_RESERVES, GET_CLAIM],
      awaitRefetchQueries: true,
    }
  );

  return {
    upsertReserve,
    loading,
    error,
    reset,
    data,
  };
}
